// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';

function Subtitle(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		color: context.themeManager.value('shopping-cart-event-subtitle', 'color', 'fg-color-text'),
		fontSize: context.themeManager.value('shopping-cart-event-subtitle', 'fontSize', 'font-size-100'),
		fontWeight: '400',
		margin: '.4em 0 0',
		wordBreak: 'keep-all',
	};

	const Headline = props.headlineLevel? props.headlineLevel : 'h2';
	return (
		props.subtitle ?
			<Headline className="shopping-cart__event-subtitle" style={style}>{props.subtitle}</Headline>
		: null
	);
}

export default radium(Subtitle);
